import { SEND_CLAIM_SUBMISSION_MAIL, SEND_DOCUMENTS } from '../../../actions/allSureMotorClaim/policyRequest';
import { AMC_REFERENCE_DATA } from '../../../actions/allSureMotorClaim/referenceData';
import { motoClaimSubmissionService } from './motoClaimSubmissionService';
import { referenceDataService } from './referenceData';
import { uploadDocumentsService } from './uploadDocumentsService';

export const allSureMotorClaimService = (store, next, action) => {
    if (action.type===SEND_DOCUMENTS) uploadDocumentsService(store, next, action);
    if (action.type===SEND_CLAIM_SUBMISSION_MAIL) motoClaimSubmissionService(store, next, action);
    if (action.type.startsWith(AMC_REFERENCE_DATA) ) return referenceDataService(store, next, action);
    return null;
};
